import CompanySingleList from './CompanySIngleList';

export default CompanySingleList;

